import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const MEDIA_PUBLIC_URL = process.env.REACT_APP_MEDIA_PUBLIC_URL || '';

export const getImagenUrl = (imagen_url) => {
  if (!imagen_url) return null;
  if (imagen_url.startsWith('http') || imagen_url.startsWith('blob:') || imagen_url.startsWith('data:')) {
    return imagen_url;
  }
  // Media servido desde Backblaze B2 publico (sin volumen local en Railway).
  if (MEDIA_PUBLIC_URL) {
    if (imagen_url.startsWith('/imagenes-productos/')) {
      return `${MEDIA_PUBLIC_URL}/imagenes_productos/${imagen_url.slice('/imagenes-productos/'.length)}`;
    }
    if (imagen_url.startsWith('/uploads/')) {
      return `${MEDIA_PUBLIC_URL}${imagen_url}`;
    }
  }
  return `${API_URL}${imagen_url}`;
};

// URL de respaldo servida por el API (volumen local). Para rutas relativas que
// aun no fueron respaldadas en B2 (p.ej. logos/comprobantes historicos).
export const getImagenFallbackUrl = (imagen_url) => {
  if (!imagen_url) return null;
  if (imagen_url.startsWith('http') || imagen_url.startsWith('blob:') || imagen_url.startsWith('data:')) {
    return null;
  }
  return `${API_URL}${imagen_url}`;
};

// Convierte una URL ya mapeada a B2 de vuelta a su ruta relativa servida por el API.
function _b2ToApiPath(src) {
  if (!MEDIA_PUBLIC_URL) return null;
  const rest = src.slice(MEDIA_PUBLIC_URL.length);
  if (rest.startsWith('/imagenes_productos/')) {
    return '/imagenes-productos/' + rest.slice('/imagenes_productos/'.length);
  }
  if (rest.startsWith('/uploads/')) {
    return rest;
  }
  return null;
}

// Fallback global: si una imagen/video servido desde B2 falla (404), reintenta
// contra el API (volumen local). Cubre media que aun no fue respaldada en B2.
export function setupMediaFallback() {
  if (typeof window === 'undefined') return;
  window.addEventListener(
    'error',
    (e) => {
      const el = e.target;
      if (!el || (el.tagName !== 'IMG' && el.tagName !== 'SOURCE' && el.tagName !== 'VIDEO')) return;
      const src = el.getAttribute('src') || el.currentSrc || '';
      if (!src || !MEDIA_PUBLIC_URL || !src.startsWith(MEDIA_PUBLIC_URL)) return;
      if (el.dataset.agxFallbackTried === '1') return;
      const apiPath = _b2ToApiPath(src);
      if (!apiPath) return;
      el.dataset.agxFallbackTried = '1';
      el.setAttribute('src', `${API_URL}${apiPath}`);
    },
    true
  );
}

const API = axios.create({
  baseURL: API_URL,
  timeout: 10000,
});

API.interceptors.request.use((config) => {
  const usuarioRaw = localStorage.getItem('usuario');
  if (usuarioRaw) {
    try {
      const usuario = JSON.parse(usuarioRaw);
      if (usuario.token) {
        config.headers['x-session-token'] = usuario.token;
      }
      if (usuario.cedula) {
        config.headers['x-user-cedula'] = usuario.cedula;
      }
    } catch (e) {
      // ignore
    }
  }
  const empresaSlug = localStorage.getItem('agorax_empresa_slug');
  if (empresaSlug) {
    config.headers['x-empresa-slug'] = empresaSlug;
  }
  return config;
});

let _onError = null;
API.setOnError = (fn) => {
  _onError = fn;
};
API._notifyError = (msgOrErr) => {
  if (typeof _onError === 'function') {
    try {
      _onError(msgOrErr);
    } catch (e) {
      console.error(msgOrErr);
    }
  }
};

API.interceptors.response.use(
  (response) => response,
  (error) => {
    API._notifyError(error);
    return Promise.reject(error);
  }
);

export const getSchemaName = () => {
  const slug = localStorage.getItem('agorax_empresa_slug');
  return slug ? slug.replace(/-/g, '_') : '';
};

export default API;
